import { render, staticRenderFns } from "./RegisterUpline.vue?vue&type=template&id=9a0f6000&scoped=true&"
import script from "./RegisterUpline.vue?vue&type=script&lang=js&"
export * from "./RegisterUpline.vue?vue&type=script&lang=js&"
import style0 from "./RegisterUpline.vue?vue&type=style&index=0&id=9a0f6000&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0f6000",
  null
  
)

export default component.exports